'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minutesAfter.js
// module id = 188
// module chunks = 0